import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGridIconSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32.002}
    height={18.001}
    data-name="Group 168"
    {...props}
  >
    <g data-name="White Box">
      <path fill="#fff" d="M31.502 17.501h-31v-17h31Z" data-name="Path 1" />
      <path
        fill="#024"
        d="M.996 1v16h30V1zm-1-1h32v18h-32Z"
        data-name="Path 2"
      />
    </g>
    <path
      fill="#024"
      d="M1.961 12.001h8.682v4.03H1.961Z"
      data-name="Grey Box"
    />
    <path
      fill="#024"
      d="M1.962 7.001h8.682v4.03H1.962Z"
      data-name="Grey Box-2"
    />
    <path
      fill="#024"
      d="M1.961 1.999h8.682v4.03H1.961Z"
      data-name="Grey Box-3"
    />
    <path
      fill="#024"
      d="M11.662 12.001h8.682v4.03h-8.682Z"
      data-name="Grey Box-4"
    />
    <path
      fill="#024"
      d="M11.664 7.001h8.682v4.03h-8.682Z"
      data-name="Grey Box-5"
    />
    <path
      fill="#024"
      d="M11.662 1.999h8.682v4.03h-8.682Z"
      data-name="Grey Box-6"
    />
    <path
      fill="#024"
      d="M21.362 12.001h8.682v4.03h-8.682Z"
      data-name="Grey Box-7"
    />
    <path
      fill="#024"
      d="M21.363 7.001h8.682v4.03h-8.682Z"
      data-name="Grey Box-8"
    />
    <path
      fill="#024"
      d="M21.362 1.999h8.682v4.03h-8.682Z"
      data-name="Grey Box-9"
    />
  </svg>
);
export default SvgGridIconSmall;
